export const ExternalSwitches = {
  WEB_ATTRIBUTION_SURVEY: "web_attribution_survey_v2",
  WEB_EXTERNAL_PARENTS_FIRST: "web_external_parents_first_v4",
  WEB_EXTERNAL_A_A_LOGGEDOUT: "web_external_a_a_loggedout",
  WEB_EXTERNAL_TRYITOUT: "web_external_try_it_out_v2",
  WEB_EXTERNAL_MOBILE_STICKY_SIGNUP: "web_external_mobile_sticky_signup",
  WEB_EXTERNAL_ACTIVITY_CORNER_POPUP_SIGNUP: "web_external_activity_corner_popup_signup",
  WEB_EXTERNAL_LOGIN_TO_HOME: "redirect_parent_login_home_v2",
  WEB_EXTERNAL_SCHOOLS_PAGE_2024: "web_external_schools_page_2024_with_form",
  WEB_EXTERNAL_TEACHER_EMAIL_FIRST_LOGIN: "web_external_teacher_email_first_login",
} as const;

export const TeacherSwitches = {} as const;

export const featureSwitches = Object.values({ ...ExternalSwitches, ...TeacherSwitches });
